import { fetchRdbmsJson, getRdbmsApiUrl } from '@/lib/rdbms-api'
import { createRemoteAutoCompleteDataFetcher } from '@/lib/remote-data/data-fetching'

export function useRemoteData() {
  const createAutocompleteFetcher = <T>(type: string) =>
    createRemoteAutoCompleteDataFetcher<T[]>(
      searchQuery =>
        getRdbmsApiUrl(`autocomplete/${type}?q=${encodeURIComponent(searchQuery.toLowerCase())}`),
      [],
    )

  const getFirstNames = createAutocompleteFetcher<FilterData.Name>('first-name')
  const getFamilyNames = createAutocompleteFetcher<FilterData.Name>('family-name')
  const getOccupations = createAutocompleteFetcher<FilterData.Occupation>('occupation')
  const getPlaces = createAutocompleteFetcher<FilterData.Place>('place')
  const getGndIds = createAutocompleteFetcher<FilterData.WikidataID>('gnd')
  const getWikidataIds = createAutocompleteFetcher<FilterData.WikidataID>('wikidata')

  // Warm up endpoint once so first autocomplete response is faster.
  fetchRdbmsJson('status').catch(() => undefined)

  return {
    getFirstNames,
    getFamilyNames,
    getOccupations,
    getWikidataIds,
    getGndIds,
    getPlaces,
  }
}
